module.exports = __webpack_public_path__ + "img/logo_sfags_blanco.47faf4b2.png";